import React, { useState } from "react";
import { Button, Card, Checkbox, EmptyState, Briefcase01, Plus } from "@opendate-app/setlist";
import StaffingSettingsLayout from "./StaffingSettingsLayout";
import DepartmentCard from "./DepartmentCard";
import DepartmentModal from "./DepartmentModal";
import PositionModal from "./PositionModal";
import { useStaffingDepartmentsContext } from "./StaffingDepartmentsContext";
import { inScope } from "./staffingScopes";

const DepartmentsBoard = () => {
  const { departments, tabPaths, permissions, permissionScopes } = useStaffingDepartmentsContext();
  const manageDepartmentIds = permissionScopes?.manageDepartmentIds;
  const canAddDepartment = manageDepartmentIds === null || manageDepartmentIds === undefined;
  const [showArchived, setShowArchived] = useState(false);
  const [editingDepartment, setEditingDepartment] = useState(null);
  const [editingPosition, setEditingPosition] = useState(null);

  const visibleDepartments = departments.filter((department) => showArchived || !department.archived);

  return (
    <StaffingSettingsLayout
      current="positions"
      title="Positions"
      description="Group the jobs your people work into departments. Each position is paid or volunteer."
      tabPaths={tabPaths}
      actions={
        permissions.manageRoster && (
          <>
            {canAddDepartment && (
              <Button variant="secondary" icon={Plus} onClick={() => setEditingDepartment({})}>
                Add department
              </Button>
            )}
            {departments.some((department) => inScope(manageDepartmentIds, department.id)) && (
              <Button variant="primary" icon={Plus} onClick={() => setEditingPosition({})}>
                Add position
              </Button>
            )}
          </>
        )
      }
    >
      <div className="mb-3">
        <Checkbox id="staffing-show-archived" label="Show archived departments and positions" checked={showArchived} onChange={(event) => setShowArchived(event.target.checked)} />
      </div>

      {visibleDepartments.length === 0 && (
        <Card padding="md">
          <EmptyState icon={Briefcase01} title="No departments yet" description="Add a department, then the positions people work in it." />
        </Card>
      )}

      {visibleDepartments.map((department, index) => (
        <DepartmentCard
          key={department.id}
          department={department}
          previousDepartment={visibleDepartments[index - 1]}
          nextDepartment={visibleDepartments[index + 1]}
          showArchived={showArchived}
          onEditDepartment={setEditingDepartment}
          onEditPosition={setEditingPosition}
        />
      ))}

      {editingDepartment && <DepartmentModal department={editingDepartment} onClose={() => setEditingDepartment(null)} />}
      {editingPosition && <PositionModal position={editingPosition} onClose={() => setEditingPosition(null)} />}
    </StaffingSettingsLayout>
  );
};

export default DepartmentsBoard;
